import { render } from "./MemberPage.vue?vue&type=template&id=5aab9070&scoped=true"
import script from "./MemberPage.vue?vue&type=script&lang=js"
export * from "./MemberPage.vue?vue&type=script&lang=js"

import "./MemberPage.vue?vue&type=style&index=0&id=5aab9070&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aab9070"]])

export default __exports__